import { Container, Group, Stack } from "@mantine/core"
import { Card } from "@tfg/ui"
import { useEffect, useLayoutEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"

import { AgecCompliance } from "~/pages/Brand/Home/components/AgecCompliance.tsx"
import { DashboardElement } from "~/pages/Brand/Home/components/DashboardElement.tsx"
import { DocumentsKPIContainer } from "~/pages/Brand/Home/components/DocumentsKPI/DocumentsKPI.container.tsx"
import { InformationRequests } from "~/pages/Brand/Home/components/InformationRequests.tsx"
import { Notifications } from "~/pages/Brand/Home/components/Notifications.tsx"
import { useFindCertificatesKpiQuery } from "~/pages/Brand/Home/hooks/useFindCertificatesKpiQuery"
import { useListInformationRequests } from "~/pages/Brand/Home/hooks/useListInformationRequests.ts"
import { useAgecComplianceProductsQuery } from "~/pages/Brand/Products/List/hooks.ts"
import { useAuth } from "~/store/auth-context.tsx"

export const Home = () => {
  const { user } = useAuth()
  const { t } = useTranslation(["home"])
  const [groupHeight, setGroupHeight] = useState<number>(600)
  const groupRef = useRef<HTMLDivElement>(null)
  const stackRef = useRef<HTMLDivElement>(null)

  const productsQuery = useAgecComplianceProductsQuery()
  const certificatesKpiQuery = useFindCertificatesKpiQuery()

  const informationRequestsQuery = useListInformationRequests(
    user?.organization?.id
  )

  const updateHeight = () => {
    if (stackRef.current) {
      setGroupHeight(stackRef.current.offsetHeight)
    }
  }

  useLayoutEffect(() => {
    updateHeight()
  })

  useEffect(() => {
    window.addEventListener("resize", updateHeight)
    return () => window.removeEventListener("resize", updateHeight)
  }, [])

  const zalandoActivated =
    user?.organization?.settings?.zalandoPlan === "ENABLED"
  return (
    <Container m={0} fluid p={0}>
      <Group grow align="top" ref={groupRef} style={{ height: groupHeight }}>
        <Stack ref={stackRef}>
          <DashboardElement
            query={informationRequestsQuery}
            title={t("informationRequests.title")}
          >
            {({ data }) => <InformationRequests informationRequests={data} />}
          </DashboardElement>
          {!zalandoActivated && (
            <DashboardElement
              query={productsQuery}
              title={t("agecCompliance.title")}
            >
              {({ data }) => <AgecCompliance products={data} />}
            </DashboardElement>
          )}
          <DashboardElement
            query={certificatesKpiQuery}
            title={t("documents.title")}
          >
            {({ data }) => <DocumentsKPIContainer data={data.data} />}
          </DashboardElement>
        </Stack>
        <Card
          mah="100%"
          style={{
            overflow: "hidden",
            position: "relative",
          }}
        >
          <Card.Header title={t("notifications.title")} />
          <Card.Section>
            <Notifications />
          </Card.Section>
        </Card>
      </Group>
    </Container>
  )
}
